<template>
  <v-container class="container">
    <v-row class="poster" justify="space-between" no-gutters>
      <v-col cols="6" class="carousel">
        <v-carousel hide-delimiters height="178" class="carousel-box">
          <v-carousel-item
            v-for="(item, i) in container[0]"
            :key="i"
            :src="item.imgUrl"
            :href="item.adUrl"
            target="_blank"
          ></v-carousel-item>
          <template v-slot:prev="{ on, attrs }">
            <div class="carousel-btn-prev" v-bind="attrs" v-on="on"></div>
          </template>
          <template v-slot:next="{ on, attrs }">
            <div class="carousel-btn-next" v-bind="attrs" v-on="on"></div>
          </template>
        </v-carousel>
      </v-col>
      <v-col cols="6" class="hot">
        <a v-if="container[1]" :href="container[1].adUrl" target="_blank">
          <v-img :src="container[1].imgUrl" height="176"></v-img>
        </a>
      </v-col>
    </v-row>
    <v-row class="activity" no-gutters>
      <v-col cols="12" class="head">
        <div class="title">活动中心</div>
        <a href="https://dnf.qq.com/act.shtml" class="more" target="_blank">
          更多
        </a>
      </v-col>
      <v-col cols="12" class="body">
        <v-carousel hide-delimiters height="100%" class="carousel-box">
          <v-carousel-item v-for="(item, i) in activity" :key="i">
            <v-row class="group" no-gutters>
              <v-col cols="3" class="item" v-for="v in item" :key="v.iActId">
                <a :href="v.sActDetailUrl" target="_blank">
                  <v-img :src="v.sBigImgUrl" height="72"></v-img>
                </a>
              </v-col>
            </v-row>
          </v-carousel-item>
          <template v-slot:prev="{ on, attrs }">
            <div class="carousel-btn-prev" v-bind="attrs" v-on="on"></div>
          </template>
          <template v-slot:next="{ on, attrs }">
            <div class="carousel-btn-next" v-bind="attrs" v-on="on"></div>
          </template>
        </v-carousel>
      </v-col>
    </v-row>
    <v-row class="advisory" no-gutters>
      <v-col cols="12" class="head">
        <div class="title">热门资讯</div>
        <a
          href="https://dnf.qq.com/webplat/info/news_version3/119/495/m394/list_1.shtml"
          class="more"
          target="_blank"
        >
          更多
        </a>
      </v-col>
      <v-col cols="12" class="body">
        <div class="news flex c sb">
          <div class="item a">
            <a
              v-if="news[0]['24470']"
              :href="news[0]['24470'].adUrl"
              target="_blank"
            >
              <v-img :src="news[0]['24470'].imgUrl" height="170"></v-img>
            </a>
          </div>
          <div class="item b">
            <a
              v-if="news[0]['24471']"
              :href="news[0]['24471'].adUrl"
              target="_blank"
            >
              <v-img :src="news[0]['24471'].imgUrl" height="170"></v-img>
            </a>
          </div>
          <div class="item c">
            <v-tabs
              background-color="transparent"
              active-class="active"
              height="29"
              hide-slider
              grow
              dark
              class="news-box"
            >
              <v-tab> 综合</v-tab>
              <v-tab> 公告</v-tab>
              <v-tab> 社区</v-tab>
              <v-tab-item active-class="active-box">
                <div class="list">
                  <div class="tr" v-for="(row, k) in news[1]" :key="k">
                    <div class="box">
                      <div class="tag">{{ row.sTypeName }}</div>
                      <a :href="row.sRedirectAddress" target="_blank">
                        {{ row.sTitle }}
                      </a>
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item active-class="active-box">
                <div class="list">
                  <div class="tr" v-for="(row, k) in news[2]" :key="k">
                    <div class="box">
                      <div class="tag">{{ row.sTypeName }}</div>
                      <a :href="row.sRedirectAddress" target="_blank">
                        {{ row.sTitle }}
                      </a>
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item active-class="active-box">
                <div class="list">
                  <div class="tr" v-for="(row, k) in news[3]" :key="k">
                    <div class="box">
                      <div class="tag">{{ row.sTypeName }}</div>
                      <a :href="row.sRedirectAddress" target="_blank">
                        {{ row.sTitle }}
                      </a>
                    </div>
                  </div>
                </div>
              </v-tab-item>
            </v-tabs>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  data: () => {
    return {
      container: [],
      activity: [],
      news: [[], [], [], []],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getContainer();
      this.getActivity();
      this.getNews();
    },
    getContainer() {
      const { common } = window.gAds15181;
      const key = [
        "15947",
        "15948",
        "15949",
        "15950",
        "15951",
        "15952",
        "15953",
      ];
      const data = [];
      for (const name in common) {
        if (key.indexOf(name) > -1) {
          data.push(common[name]);
        }
      }

      this.container[0] = data;
      this.container[1] = common["24469"];
    },
    getActivity() {
      let i = 0;
      let arr = [];

      const dao = window.DNF_ACTLIST_ONLINE_3.filter((v) => {
        if (v.dtEnd === "3000-01-01") {
          return false;
        }
        return !(v.sBigImgUrl === "0" || v.sBigImgUrl === "");
      });

      dao.map((v) => {
        if (!arr[i]) {
          arr[i] = [];
        }

        v.sBigImgUrl = decodeURIComponent(v.sBigImgUrl);
        v.sActDetailUrl = decodeURIComponent(v.sActDetailUrl);

        arr[i].push(v);

        if (arr[i].length === 4) {
          i++;
        }
      });

      this.activity = arr;
    },
    getNews() {
      this.news[0] = window.gAds15181.common;
      const getScript = (src, fun) => {
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = src;
        document.getElementsByTagName("body")[0].appendChild(s);
        s.onload = fun;
      };

      getScript(
        "https://dnf.qq.com/webplat/info/news_version3/119/495/m22522/index.js",
        () => {
          this.$set(
            this.news,
            1,
            window.newsIndexData
              .map((v) => {
                v.sTitle = decodeURIComponent(v.sTitle);
                v.sTypeName = decodeURIComponent(v.sTypeName);
                v.sRedirectAddress = v.sRedirectAddress
                  ? decodeURIComponent(v.sRedirectAddress)
                  : "https://dnf.qq.com/" + decodeURIComponent(v.infoPath);
                return v;
              })
              .slice(0, 4)
          );

          getScript(
            "https://dnf.qq.com/webplat/info/news_version3/119/495/498/m388/index.js",
            () => {
              this.$set(
                this.news,
                2,
                window.newsIndexData
                  .map((v) => {
                    v.sTitle = decodeURIComponent(v.sTitle);
                    v.sTypeName = decodeURIComponent(v.sTypeName);
                    v.sRedirectAddress = v.sRedirectAddress
                      ? decodeURIComponent(v.sRedirectAddress)
                      : "https://dnf.qq.com/" + decodeURIComponent(v.infoPath);
                    return v;
                  })
                  .slice(0, 4)
              );

              getScript(
                "https://dnf.qq.com/webplat/info/news_version3/119/506/509/m390/index.js",
                () => {
                  this.$set(
                    this.news,
                    3,
                    window.newsIndexData
                      .map((v) => {
                        v.sTitle = decodeURIComponent(v.sTitle);
                        v.sTypeName = decodeURIComponent(v.sTypeName);
                        v.sRedirectAddress = v.sRedirectAddress
                          ? decodeURIComponent(v.sRedirectAddress)
                          : "https://dnf.qq.com/" +
                            decodeURIComponent(v.infoPath);
                        return v;
                      })
                      .slice(0, 4)
                  );
                }
              );
            }
          );
        }
      );
    },
  },
};
</script>

<style lang="scss">
.container {
  .v-window__prev,
  .v-window__next {
    background: none;
  }
}
.activity {
  .v-window__prev,
  .v-window__next {
    width: 29px;
    height: 45px;
    background: none;
  }
  .v-window__prev {
    left: -10px !important;
  }
  .v-window__next {
    right: -10px !important;
  }
}
.news-box {
  .theme--light.v-tabs-items {
    background-color: transparent;
  }
}
</style>
<style scoped lang="scss">
.container {
  padding: 18px 3px 0 3px;
  width: 772px;
  overflow: hidden;

  .poster {
    color: #fff;

    .carousel {
      padding-right: 3px;
      .carousel-box {
        border: 1px solid rgba(255, 255, 255, 0.2);
      }
      .carousel-btn-prev,
      .carousel-btn-next {
        cursor: pointer;
        opacity: 0.7;
      }
      .carousel-btn-prev:hover,
      .carousel-btn-next:hover {
        opacity: 1;
      }
      .carousel-btn-prev {
        background-color: transparent;
        background-image: url("~@/assets/img/dnf/left.png");
        background-position: center;
        background-size: cover;
        width: 29px;
        height: 42px;
      }
      .carousel-btn-next {
        background-color: transparent;
        background-image: url("~@/assets/img/dnf/right.png");
        background-position: center;
        background-size: cover;
        width: 29px;
        height: 42px;
      }
    }
    .hot {
      padding-left: 3px;
      overflow: hidden;
      a {
        display: block;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }
    }
  }

  .advisory,
  .activity {
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(181, 181, 181, 0.15);
    padding: 1px;
    .head {
      position: relative;
      border: 1px solid rgba(181, 181, 181, 0.15);

      .title {
        background-image: -webkit-linear-gradient(bottom, #a67642, #f7dcaf);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        padding-left: 10px;
        height: 29px !important;
        line-height: 29px !important;
        font-weight: bold !important;
        text-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.4);
        font-size: 14px !important;
      }
      .more {
        background-image: -webkit-linear-gradient(bottom, #a67642, #f7dcaf);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        height: 29px !important;
        line-height: 29px !important;
        position: absolute;
        right: 10px;
        top: 0;
        font-size: 12px !important;
        text-decoration: underline #a67642;
      }
      .more:hover {
        background-image: -webkit-linear-gradient(bottom, #a67642, #fff);
      }
    }
  }

  .activity {
    margin-top: 7px;

    .body {
      .carousel-box {
        .carousel-btn-prev,
        .carousel-btn-next {
          width: 29px;
          height: 45px;
          cursor: pointer;
          background-size: cover !important;
          opacity: 0.7;
        }

        .carousel-btn-prev:hover,
        .carousel-btn-next:hover {
          opacity: 1;
        }

        .carousel-btn-prev {
          background-image: url("~@/assets/img/dnf/left-1.png");
        }

        .carousel-btn-next {
          background-image: url("~@/assets/img/dnf/right-1.png");
        }

        .group {
          padding: 5px 38px;
          .item {
            padding: 0 5px;
            a {
              display: block;
            }
          }
        }
      }
    }
  }

  .advisory {
    margin-top: 7px;
    .news {
      padding-top: 5px;

      .a,
      .b {
        width: 208px;
        overflow: hidden;
        a {
          display: block;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
      }

      .c {
        width: 337px;
      }

      .news-box {
        height: 172px;
        border: 1px solid rgba(181, 181, 181, 0.15);
        padding: 1px;

        .v-tab {
          background-image: url("~@/assets/img/dnf/news-tags-bg.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100%;
        }

        .active {
          background-image: url("~@/assets/img/dnf/news-tags-active-bg.png");
        }

        .v-tabs-items {
          background-color: transparent;
        }

        .v-window-item {
          .list {
            padding-top: 6px;
          }

          .tr {
            position: relative;
            padding-left: 71px;
            padding-right: 16px;
            line-height: 32px;
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            a {
              color: #a5b1c7;
            }
            a:hover {
              color: #fff;
            }
            .tag {
              background-image: url("~@/assets/img/dnf/news-tag.png");
              background-size: 100%;
              position: absolute;
              top: 50%;
              left: 16px;
              color: #8594bd;
              font-size: 10px;
              width: 45px;
              height: 18px;
              text-align: center;
              line-height: 18px;
              margin-top: -9px;
            }
          }

          .tr:last-child {
            padding: 0 16px;
            .box {
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #2c1d4f;
              text-align: center;
              height: 29px;
              line-height: 29px;
              border: 1px solid #2c1d4f;
              .tag {
                background-image: none;
                position: unset;
                border: none;
                padding: 0;
                margin-top: 0;
                margin-right: 2px;
                font-weight: bold;
                font-size: 12px;
                height: 29px;
                line-height: 29px;
              }
              a {
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .tag::before,
              .tag::after {
                display: inline;
                font-weight: bold;
              }
              .tag::before {
                content: "【";
              }
              .tag::after {
                content: "】";
              }
            }
          }

          .tr:last-child::before {
            display: none;
          }

          .tr:first-child::before {
            display: none;
          }

          .tr::before {
            position: absolute;
            content: "";
            top: 0;
            height: 1px;
            left: 16px;
            right: 16px;
            background-image: linear-gradient(
              to left,
              rgba(255, 255, 255, 0.1) 0%,
              rgba(255, 255, 255, 0.3) 40%,
              rgba(255, 255, 255, 0.3) 60%,
              rgba(255, 255, 255, 0.1) 100%
            );
          }
        }
      }
    }
  }
}
</style>
